// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';

import ContainerModal from 'wdna-components/lib/modals/generics/ContainerModal';

import { WasteInfoDO } from '../../../requests';
import './RecalibrateModal.css';

/**
 * Generate the TZ offset string of date
 *
 * @param date to calculate the tz offset
 * @returns string with the offset info
 */
function getTimeZoneOffset(date?: Date): string {
  let result: string = '';
  if (date) {
    const tzOffset: { hours: number; minutes: number; } = {
      hours: Math.trunc(-date.getTimezoneOffset() / 60),
      minutes: -date.getTimezoneOffset() % 60,
    };
    result = `UTC ${tzOffset.hours < 0 ? '-' : '+'}${String(tzOffset.hours).padStart(2, '0')}:${String(tzOffset.minutes).padStart(2, '0')}`;
  }

  return result;
}

interface Props {
  show?: boolean;
  title?: string;
  formValues: {
    newRecal?: boolean;
    info?: Partial<WasteInfoDO>;
  };
  className?: string;
  onSave: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement> | Date | null) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function RecalibrateModal(props: Props): JSX.Element {
  const { newRecal, info } = props.formValues;
  const timezoneString: string = getTimeZoneOffset(info?.date);

  return (
    <ContainerModal
      fullScreenButton={false}
      show={props.show}
      title={props.title}
      modalClass="modal-small selector-modal"
      onClose={props.onCancel}
      footerButtons={[
        {
          text: 'Close',
          className: 'btn btn-primary',
          onClick: props.onCancel,
        },
        {
          text: 'Save',
          className: 'btn btn-primary',
          onClick: props.onSave,
        },
      ]}
    >
      <fieldset>
        <div className="row">
          <div className="col-8">
            <label className="label">
              <b>Date</b>
            </label>
            <i className="fa fa-calendar">
              <DatePicker
                selected={info?.date}
                onChange={props.onChange}
                className="inputNew"
                name="date"
                showTimeSelect
                timeFormat="HH:mm:ss"
                timeIntervals={15}
                dateFormat={`yyyy-MM-dd HH:mm:ss '${timezoneString}'`}
                timeCaption="time"
                todayButton="TODAY"
                disabled={!newRecal}
              />
            </i>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-1</b>
            </label>
            &nbsp;
            <input
              className="inputNew"
              type="number"
              value={info?.ratio1 || 0}
              name="ratio1"
              onChange={props.onChange}
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-2</b>
            </label>
            &nbsp;
            <input
              className="inputNew"
              type="number"
              value={info?.ratio2 || 0}
              name="ratio2"
              onChange={props.onChange}
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-3</b>
            </label>
            &nbsp;
            <input
              className="inputNew"
              type="number"
              value={info?.ratio3 || 0}
              name="ratio3"
              onChange={props.onChange}
              required
            />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-6">
            <label className="label">
              <b>Ratio Wheel-4</b>
            </label>
            &nbsp;
            <input
              className="inputNew"
              type="number"
              value={info?.ratio4 || 0}
              name="ratio4"
              onChange={props.onChange}
              required
            />
          </div>
        </div>
      </fieldset>
    </ContainerModal>
  );
}

RecalibrateModal.defaultProps = {
  show: false,
  title: '',
  className: '',
};
